import { faBoltAuto } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Checkbox } from 'components/form/checkbox'
import { FC, useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Tooltip } from '@lib/tooltip'
import { ContingentWorkerType } from 'types'

type Props = {
  checked: boolean
  contigentWorkerType: ContingentWorkerType | null
  disabled?: boolean
  indeterminate: boolean
  adminManagedGroup: BasicAdminManagedGroup | null
  linkPath?: string
  name: string
  onChange: (checked: boolean) => void
  payType: 'salary' | 'hourly' | null
  title?: string | null
}

export const EmployeeCell: FC<Props> = ({
  checked,
  contigentWorkerType,
  disabled = false,
  indeterminate,
  adminManagedGroup,
  linkPath,
  name,
  onChange,
  payType,
  title,
}) => {
  const { t } = useTranslation()
  const id = useId()

  return (
    <div className="px-4">
      <div className="flex flex-row items-center w-60 2xl:w-72">
        <Checkbox
          checked={checked}
          disabled={disabled}
          indeterminate={indeterminate && !checked}
          onChange={() => onChange(!checked)}
        />
        <div className="flex flex-col ml-2 overflow-hidden grow">
          <span className="text-sm font-semibold truncate text-neutral-900">
            {linkPath ? <Link to={linkPath}>{name}</Link> : name}
          </span>
          <span className="text-xs truncate">
            {title}
            {title && <span className="mx-1 text-xs text-neutral-400">•</span>}
            {payType && t(`payTypes.${payType}`)}
            {contigentWorkerType &&
              t(`contingentWorkerTypes.${contigentWorkerType}`)}
          </span>
        </div>
        {adminManagedGroup && (
          <>
            <FontAwesomeIcon
              className="text-neutral-700"
              icon={faBoltAuto}
              data-tooltip-id={id}
            />
            <Tooltip id={id} className="z-20">
              <div className="text-center">
                <div className="font-bold">{t('common.adminManaged')}</div>
                {adminManagedGroup.name}
              </div>
            </Tooltip>
          </>
        )}
      </div>
    </div>
  )
}
